import { actionTypes } from "./actionTypes";
export const setMode = (mode) => ({
    type: actionTypes.SET_MODE,
    mode
})